var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-938 -614)",
    clipPath: "url(#lock-open_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M957.619 639.238a1.9 1.9 0 10-1.9-1.9 1.91 1.91 0 001.9 1.9zm5.714-8.571h-.952v-1.9a4.762 4.762 0 00-9.524 0h1.81a2.952 2.952 0 115.9 0v1.9H951.9a1.91 1.91 0 00-1.9 1.9v9.533a1.91 1.91 0 001.9 1.9h11.433a1.91 1.91 0 001.9-1.9v-9.529a1.91 1.91 0 00-1.9-1.904zm0 11.429H951.9v-9.525h11.433z",
    fill: "currentColor"
  }))));
}
export default SvgLockOpen;